// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__29vxp","label":"Category_label__34gyT","content":"Category_content__3dq_y","header":"Category_header__1V00z","location":"Category_location__1AVY5"};